module.exports = __webpack_public_path__ + "media/images/quotes-7c09f00a37831cf02e82477055712811.svg";